import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { recommendationConfigs } from '@bingads-webui-campaign/recommendation-core';
import template from './one-line-text.pug';

export class RecommendationTypeColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    const title = i18n.getString('ColumnName_RecommendationType');
    super({
      name: 'RecommendationType',
      property: 'RecommendationResult/RecommendationType',
      title,
      bodyClasses: ['grid-column-recommendation-type'],
      colClasses: ['col-text'],
    });

    this.i18n = i18n;
    this.newI18n = newI18n;
  }


  template({
    value: {
      RecommendationType,
    },
  }) {
    const recommendationConfig = recommendationConfigs[RecommendationType];
    if (_.isUndefined(recommendationConfig)) {
      return null;
    }

    const useNewI18n = !_.isUndefined(recommendationConfig.useNewI18n) ?
      recommendationConfig.useNewI18n : false;

    return template({
      content: useNewI18n ?
        this.newI18n.getString(recommendationConfigs[RecommendationType].summaryTitle) :
        this.i18n.getString(recommendationConfigs[RecommendationType].summaryTitle),
    });
  }

  get property() {
    return {
      get: _.identity,
    };
  }
}
